var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "780px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("edit")]),
              _vm._v(" Compensar permiso\n        "),
              _c("v-spacer"),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.horas_disponibles === null
                      ? ""
                      : "Tiene " + _vm.horas_disponibles + " horas disponibles"
                  ) +
                  "\n        "
              ),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.adicionarDetalle()
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-container",
                    { staticClass: "pt-0", attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.tipo_permisos,
                                  "item-value": "id",
                                  "item-text": "descripcion",
                                  label: "Solicitar permiso",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.id_permi,
                                  callback: function($$v) {
                                    _vm.id_permi = $$v
                                  },
                                  expression: "id_permi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.id_permi == 87
                            ? _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Comisión a",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      disabled: _vm.permiso_detalles.length > 0
                                    },
                                    model: {
                                      value: _vm.permi_lugar,
                                      callback: function($$v) {
                                        _vm.permi_lugar = $$v
                                      },
                                      expression: "permi_lugar"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 88 || _vm.id_permi == 96
                            ? _c("v-flex", { attrs: { md4: "" } }, [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      "Total horas a compensar:  " +
                                        _vm._s(_vm.total_horas_permiso) +
                                        " "
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                on: {
                                  input: function() {
                                    return (_vm.permisoDetalle.fecha_hasta =
                                      _vm.permisoDetalle.fecha_desde)
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "time",
                                  label: "Hora desde",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  disabled:
                                    _vm.permiso_detalles.length > 0 &&
                                    _vm.id_permi.id_tipo_permiso == 87
                                },
                                model: {
                                  value: _vm.form.hora_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "hora_desde", $$v)
                                  },
                                  expression: "form.hora_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "time",
                                  label: "Hora hasta",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  disabled:
                                    _vm.permiso_detalles.length > 0 &&
                                    _vm.id_permi.id_tipo_permiso == 87
                                },
                                model: {
                                  value: _vm.form.hora_hasta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "hora_hasta", $$v)
                                  },
                                  expression: "form.hora_hasta"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "success",
                                    block: "",
                                    type: "submit",
                                    disabled: !_vm.valid
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("arrow_downward")]),
                                  _vm._v(
                                    "\n                  Registrar\n                "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.permiso_detalles.length > 0
                ? _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      items: _vm.permiso_detalles,
                                      "hide-actions": "",
                                      headers: _vm.headers
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            props.item
                                                              .fecha_desde
                                                          )
                                                          .format("DD/MM/YYYY")
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            props.item
                                                              .fecha_hasta
                                                          )
                                                          .format("DD/MM/YYYY")
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.hora_desde
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.hora_hasta
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.total) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.horas_compensa
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "error",
                                                        icon: "",
                                                        title: "Eliminar"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.eliminarDetalle()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("delete")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3966595519
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.horas_solicitadas != 0
                            ? _c(
                                "v-layout",
                                { staticClass: "pa-2" },
                                [
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs3: "" } }, [
                                    _c("h4", [
                                      _c("strong", [_vm._v("Total horas:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.horas_solicitadas.toFixed(2)
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _vm.permiso_compensacion != null
                        ? _c("h3", [
                            _c("strong", [_vm._v("Detalles compensacion")])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_compensacion,
                                  "hide-actions": "",
                                  headers: _vm.headers
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.fecha_desde
                                                    )
                                                    .format("DD/MM/YYYY")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.fecha_hasta
                                                    )
                                                    .format("DD/MM/YYYY")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.hora_desde)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.hora_hasta)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item.diferencia_horas
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "error",
                                                  icon: "",
                                                  title: "Eliminar compensacion"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.eliminarDetalleCompensa(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [_vm._v("delete")])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { staticClass: "pa-2" },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", [
                              _c("strong", [
                                _vm._v(
                                  "Total horas: " +
                                    _vm._s(_vm.total_horas_acomuladas)
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pr-4" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v("CERRAR\n          ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1283d4e7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1283d4e7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/CompensarPermisoTolerancia.vue
// module id = null
// module chunks = 